import { motion } from 'framer-motion'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: ${({ theme }) => theme.UI.SpacingPx.Space4} 0;
`

const StHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: ${({ theme }) => theme.UI.SpacingPx.Space6};
`

const StIFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;

  max-width: 899px;

  padding-bottom: calc(
    max(var(--safe-area-inset-bottom, 0px), 20px) +
      ${({ theme }) => theme.UI.Spacing.Space1}px
  );
  @media (${breakpoints.fromM}) {
    padding-bottom: calc(
      max(var(--safe-area-inset-bottom, 0px), 20px) +
        ${({ theme }) => theme.UI.Spacing.Space6}px
    );
  }
`

const AnimatedContainer = motion(StContainer)

export { AnimatedContainer, StHeader, StIFrame }
